'use client';

import {Box, styled} from '@mui/material';

export const StyledHeroMediaContainer = styled(Box)(({theme}) => ({
  position: 'relative',
  width: '100%',
  minHeight: '100vh',
  overflow: 'hidden',
  marginBottom: theme.spacing(10),
}));

export const StyledHeroImage = styled('img')({
  width: '100%',
  height: '100vh',
  objectFit: 'cover',
  display: 'block',
});
